import React from 'react';
import { MYACCOUNTPAGE } from 'npmlinks-constants';
import {GridRow, GridColumn} from "arv-reactcomponents";

const { LOYALTY } = MYACCOUNTPAGE;
const LoyaltyTierHeader = () => (
  <GridRow className="nw-loyaltymodal-subheading">
    <GridColumn className="nwc-grid-col-xs-4">
      {LOYALTY.LOYALTY_TIER}
    </GridColumn>
    <GridColumn className="nwc-grid-col-xs-4 nw-loyaltymodal-textcenter">
      {LOYALTY.UPGRADE_CRITERIA}
    </GridColumn>
    <GridColumn className="nwc-grid-col-xs-4 nw-loyaltymodal-textright">
      {LOYALTY.EARN}
    </GridColumn>
  </GridRow>
)

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrappedComponent: LoyaltyTierHeader,
  component: LoyaltyTierHeader,
}

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/MyAccountLoyalty/LoyaltyMoreInfoModal/LoyaltyTiersBlock/LoyaltyTierHeader/index.js